// @flow

import { CHATBOT_EVENTS, EVENT_SENDERS, WIZARD_EVENTS } from '../types'

import {
  MESSAGE_TYPE_ADD_TO_CART,
  MESSAGE_TYPE_CHAT_ICON_CLICKED,
  MESSAGE_TYPE_CLOSED,
  MESSAGE_TYPE_LOADED,
  MESSAGE_TYPE_PRODUCT_BUTTON, MESSAGE_TYPE_PRODUCTS,
  MESSAGE_TYPE_RESTART,
  MESSAGE_TYPE_STARTED,
  MESSAGE_TYPE_URL_BUTTON,
  MESSAGE_TYPE_USER_ATTRIBUTE_SET,
  MESSAGE_TYPE_WELCOME_MESSAGE_CLICKED,
  MESSAGE_TYPE_WELCOME_MESSAGE_CLOSED
} from '../../../common/iframeMessageTypes'

// this map maps new event names to the old ones that are used to hold the config in the database
// ideally the database is migrated to only use the new event names
export const WebAnalyticsEventMap: Object = {
  [CHATBOT_EVENTS.Loaded]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_LOADED
  },
  [CHATBOT_EVENTS.WelcomeMessageClick]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_WELCOME_MESSAGE_CLICKED
  },
  [CHATBOT_EVENTS.WelcomeMessageClosed]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_WELCOME_MESSAGE_CLOSED
  },
  [CHATBOT_EVENTS.OpenChatClick]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_CHAT_ICON_CLICKED
  },
  [CHATBOT_EVENTS.CloseChatClick]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_CLOSED
  },
  [CHATBOT_EVENTS.Started]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_STARTED
  },
  [CHATBOT_EVENTS.Restarted]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_RESTART
  },
  [CHATBOT_EVENTS.UrlButtonClicked]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_URL_BUTTON
  },
  [CHATBOT_EVENTS.RecommendedProductClicked]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_PRODUCT_BUTTON
  },
  [CHATBOT_EVENTS.AddedToCart]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_ADD_TO_CART
  },
  [CHATBOT_EVENTS.RoutineAddedToCart]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_ADD_TO_CART
  },
  [CHATBOT_EVENTS.Completed]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_PRODUCTS
  },
  [CHATBOT_EVENTS.AttributeSet]: {
    eventSender: EVENT_SENDERS.CHATBOT,
    eventName: MESSAGE_TYPE_USER_ATTRIBUTE_SET
  },
  [WIZARD_EVENTS.Loaded]: {
    eventSender: EVENT_SENDERS.WIZARD,
    eventName: MESSAGE_TYPE_LOADED
  },
  [WIZARD_EVENTS.Started]: {
    eventSender: EVENT_SENDERS.WIZARD,
    eventName: MESSAGE_TYPE_STARTED
  },
  [WIZARD_EVENTS.RestartedEvent]: {
    eventSender: EVENT_SENDERS.WIZARD,
    eventName: MESSAGE_TYPE_RESTART
  },
  [WIZARD_EVENTS.RecommendedProductClicked]: {
    eventSender: EVENT_SENDERS.WIZARD,
    eventName: MESSAGE_TYPE_PRODUCT_BUTTON
  },
  [WIZARD_EVENTS.Completed]: {
    eventSender: EVENT_SENDERS.WIZARD,
    eventName: MESSAGE_TYPE_PRODUCTS
  },
  [WIZARD_EVENTS.AddedToCartEvent]: {
    eventSender: EVENT_SENDERS.WIZARD,
    eventName: MESSAGE_TYPE_ADD_TO_CART
  }
}
